const SettingsActionPriorities = () => import('frontend/pages/settings/SettingsActionPriorities')
const SettingsActionsNotifications = () => import('frontend/pages/settings/SettingsActionsNotifications')
const SettingsActionsOnlyOwner = () => import('frontend/pages/settings/SettingsActionsOnlyOwner')
const SettingsActionsSource = () => import('frontend/pages/settings/SettingsActionsSource')
const SettingsActionCategories = () => import('frontend/pages/settings/SettingsActionCategories')
const SettingsActionDetails = () => import('frontend/pages/settings/actions/action-details/SettingsActionDetails.vue')

import { LEANCENTER_SOURCE } from "frontend/constants/actions"
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [
  {
    path: 'actions-source',
    name: SETTINGS_CARDS_TOKENS.actionsSource.name,
    components: {
      default: SettingsActionsSource,
    },
    props: { default: { source: LEANCENTER_SOURCE } },
  },
  {
    path: 'actions-notifications',
    name: SETTINGS_CARDS_TOKENS.actionsNotification.name,
    components: {
      default: SettingsActionsNotifications,
    },
    props: { default: { source: LEANCENTER_SOURCE } },
  },
  {
    path: 'action-categories',
    name: SETTINGS_CARDS_TOKENS.actionsCategories.name,
    components: {
      default: SettingsActionCategories,
    },
    props: { default: { source: LEANCENTER_SOURCE } },
  },
  {
    path: 'action-priorities',
    name: SETTINGS_CARDS_TOKENS.actionsPriorities.name,
    components: {
      default: SettingsActionPriorities,
    },
    props: { default: { source: LEANCENTER_SOURCE } },
  },
  {
    path: 'actions-only-owner',
    name: SETTINGS_CARDS_TOKENS.actionsOnlyOwner.name,
    components: {
      default: SettingsActionsOnlyOwner,
    },
  },
  {
    path: 'action-details',
    name: SETTINGS_CARDS_TOKENS.actionDetails.name,
    components: {
      default: SettingsActionDetails,
    },
  },

]
